<template>
  <div></div>
</template>

<script>
  export default {
    name: 'App',
    computed: {},
  }
</script>
